import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button", "panel"]
  static values = { active: { type: String, default: "devices" } }

  switch(event) {
    this.activeValue = event.currentTarget.dataset.tab
  }

  activeValueChanged() {
    this.buttonTargets.forEach((btn) => {
      const isActive = btn.dataset.tab === this.activeValue
      btn.classList.toggle("bg-[var(--color-primary)]", isActive)
      btn.classList.toggle("text-white", isActive)
      btn.classList.toggle("text-[var(--color-base-muted)]", !isActive)
    })

    this.panelTargets.forEach((panel) => {
      panel.hidden = panel.dataset.tab !== this.activeValue
    })
  }
}
